 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLEPAGE from '@/components/titlepage'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED4 from '@/components/Untitled4'
 import A0210135E_SPLIT_006 from '@/components/20210135e_split_006'
 import A0210135E_SPLIT_007 from '@/components/20210135e_split_007'
 import CHAP2 from '@/components/chap2'
 import CHAP3 from '@/components/chap3'
 import CHAP4 from '@/components/chap4'
 import CHAP5 from '@/components/chap5'
 import PART2 from '@/components/part2'
 import CHAP6 from '@/components/chap6'
 import CHAP7 from '@/components/chap7'
 import CHAP8 from '@/components/chap8'
 import CHAP9 from '@/components/chap9'
 import CHAP10 from '@/components/chap10'
 import PART3 from '@/components/part3'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import CHAP14 from '@/components/chap14'
 import PART4 from '@/components/part4'
 import CHAP15 from '@/components/chap15'
 import CHAP16 from '@/components/chap16'
 import AUTHORNOTE from '@/components/authornote'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/Copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled4",
 			"name" : "Untitled4",
 			"component" : UNTITLED4
 		},
 		{
 			"path" : "/20210135e_split_006",
 			"name" : "20210135e_split_006",
 			"component" : A0210135E_SPLIT_006
 		},
 		{
 			"path" : "/20210135e_split_007",
 			"name" : "20210135e_split_007",
 			"component" : A0210135E_SPLIT_007
 		},
 		{
 			"path" : "/chap2",
 			"name" : "chap2",
 			"component" : CHAP2
 		},
 		{
 			"path" : "/chap3",
 			"name" : "chap3",
 			"component" : CHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js